
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQSection from './FAQKeyword';
import Testimonialskeyword from './TestimonialKeyword';
function Luxuryforceurbaniaonrent() {



    const cardData =
    {
        keyword: '   Luxury Force Urbania on Rent in Pune',
        heading: 'Samarth Travels:  Luxury Force Urbania on Rent in Pune',
        headingDescription: 'Samarth Travels offers Luxury Force Urbania on rent in Pune, perfect for premium travel experiences, corporate rides, and family trips. Enjoy plush interiors, push-back seats, and smooth rides in our well-maintained Urbania vans driven by professional chauffeurs. With transparent pricing, no hidden charges, and a focus on comfort and punctuality, Samarth Travels ensures a stylish and hassle-free journey.',

        top: 'Top Places to Visit in Pune with Samarth Travels',

       "topPlaces": [
         {
      "title": "Aga Khan Palace",
      "description": "Built in 1892 by Sultan Aga Khan III, this sprawling palace is an architectural gem and a key monument in India’s freedom struggle. It served as a prison for Mahatma Gandhi, Kasturba Gandhi, and other leaders during the Quit India Movement. The palace features Italian arches, sprawling gardens, and houses a museum that contains personal belongings of Gandhi and historical photographs. It is also the final resting place of Kasturba Gandhi and Mahadev Desai, adding to its solemn importance."
    },
        {
      "title": "Shaniwar Wada",
      "description": "Shaniwar Wada is a majestic 18th-century fortification located in the heart of Pune. Once the seat of the powerful Peshwas of the Maratha Empire, it is renowned for its historical significance, massive gateways, and intriguing legends, including ghost stories tied to its mysterious past. Despite being partially destroyed by fire, the remaining structures, especially the Delhi Gate and the fort’s expansive garden layout, provide a fascinating glimpse into Maratha architecture and political history."
    },
    {
      "title": "Sinhagad Fort",
      "description": "Located about 30 kilometers from Pune, Sinhagad Fort sits atop the Sahyadri mountains and is a favorite trekking destination for locals and tourists alike. With a history dating back over a thousand years, the fort was famously the site of the battle between the Marathas and the Mughals in 1670. Visitors are drawn to its rugged beauty, crumbling fortifications, and sweeping views of the surrounding valleys, especially during monsoons when the hills are lush green and covered in mist."
    },
    {
      "title": "Pataleshwar Cave Temple",
      "description": "This 8th-century rock-cut temple is carved entirely from a single basalt rock and dedicated to Lord Shiva. Nestled quietly amidst urban Pune, Pataleshwar offers a striking contrast to the city’s bustle. It features a circular Nandi Mandapa and intricately carved columns and sanctums. A protected monument under the Archaeological Survey of India, it’s a peaceful retreat and an excellent example of early Indian rock architecture."
    },
    {
      "title": "Dagdusheth Halwai Ganpati Temple",
      "description": "One of the most famous Ganesh temples in India, Dagdusheth Halwai Ganpati Temple attracts millions of devotees every year, especially during Ganesh Chaturthi. The temple’s grand idol of Lord Ganesh is adorned with gold and jewelry, symbolizing prosperity and devotion. Built by a sweetmaker in the 1800s, the temple also engages in numerous social and cultural initiatives, making it both a religious and community hub."
    },
    {
      "title": "Raja Dinkar Kelkar Museum",
      "description": "Founded by Dr. Dinkar Kelkar in memory of his son, this museum is a treasure trove of Indian heritage. It houses over 20,000 artifacts, including musical instruments, ancient utensils, sculptures, paintings, and even quirky items like betel nut crackers and door frames. The collection offers insight into the daily lives and traditions of Indians across centuries, and its carefully curated exhibits make it a cultural landmark in Pune."
    },
    {
      "title": "Parvati Hill and Temple",
      "description": "Parvati Hill is one of Pune’s oldest heritage sites and offers a combination of spiritual serenity and scenic views. Climbing 103 steps leads to a temple complex dedicated to Goddess Parvati and Lord Shiva. The hill also hosts a small museum, Peshwa-era relics, and panoramic views of the cityscape below, making it ideal for morning walks and peaceful contemplation."
    },
    {
      "title": "Osho Ashram",
      "description": "Located in the serene and green Koregaon Park area, the Osho International Meditation Resort is a global center for spiritual seekers. It offers dynamic meditation sessions, wellness therapies, and luxurious facilities in a Zen-like atmosphere. Known for attracting international visitors, the ashram promotes mindfulness, inner peace, and holistic living through Osho’s teachings."
    },
    {
      "title": "Pune Okayama Friendship Garden",
      "description": "Inspired by the 300-year-old Okayama Korakuen Garden in Japan, this beautifully landscaped space—also known as Pu La Deshpande Garden—is perfect for nature lovers and photographers. The garden features flowing streams, lush lawns, bridges, and seasonal flowers, offering a tranquil escape right in the city. It’s ideal for evening walks and peaceful getaways."
    },
    {
      "title": "Katraj Snake Park and Rajiv Gandhi Zoological Park",
      "description": "Spread over 130 acres, this complex features a zoo, snake park, and animal rescue center. The snake park houses over 160 species of snakes, including cobras and pythons, while the zoo includes tigers, leopards, elephants, and more. Educational exhibits make it an informative and fun spot for children and families, combining entertainment with awareness about wildlife conservation."
    }
  ],

"services": [
    {
        "name": "Rent Luxury Force Urbania in Pune",
        "description": "Experience top-tier group travel with Samarth Travels’ Luxury Force Urbania rental in Pune. This premium vehicle offers plush interiors, smooth performance, and ample space—perfect for business, leisure, or VIP travel."
    },
    {
        "name": "Affordable Luxury Force Urbania Bus Hire Pune",
        "description": "Enjoy luxury travel without breaking the bank. Samarth Travels offers affordable Luxury Force Urbania bus hire services in Pune, ideal for family tours, sightseeing, and comfortable corporate transit."
    },
    {
        "name": "Luxury Urbania Rental Service Pune",
        "description": "Samarth Travels provides reliable and premium Luxury Urbania rental services in Pune. This high-end vehicle is designed for travelers seeking both comfort and class on their journey—local or outstation."
    },
    {
        "name": "Rent a Luxury Force Urbania Bus for Corporate Events in Pune",
        "description": "Make a lasting impression at your next corporate event with our Luxury Force Urbania rental. Perfect for transporting executives or teams in style and comfort across Pune and beyond."
    },
    {
        "name": "Luxury Urbania Bus Hire for Wedding Functions Pune",
        "description": "Transport your wedding guests in elegance with our Luxury Force Urbania hire in Pune. The stylish interiors and smooth ride add a touch of class to any wedding event."
    },
    {
        "name": "Force Urbania Luxury Bus for Family Trips Pune",
        "description": "Planning a family outing? Travel together in comfort with our Force Urbania luxury bus. Ideal for weekend getaways or long vacations from Pune with enough space for everyone to relax."
    },
    {
        "name": "Rent Luxury Urbania Bus for Outstation Tours in Pune",
        "description": "Heading out of town? Rent a Luxury Force Urbania from Samarth Travels for your outstation trip from Pune. Enjoy a hassle-free, smooth, and stylish journey to any destination."
    },
    {
        "name": "Urbania Luxury Bus Hire for Group Travel Pune",
        "description": "Whether it’s a social event or a corporate outing, our Urbania luxury bus is perfect for group travel. Enjoy ergonomic seating, air conditioning, and a peaceful travel environment."
    },
    {
        "name": "Luxury Urbania Bus on Rent for Sightseeing Tours Pune",
        "description": "Explore Pune and nearby destinations in comfort and style. Rent a Luxury Force Urbania for sightseeing tours, ideal for families, tourists, or business groups looking to enjoy the journey as much as the destination."
    },
    {
        "name": "Rent a Luxury Urbania Bus for School Trips Pune",
        "description": "Upgrade school excursions with a Luxury Force Urbania rental in Pune. This premium vehicle offers safety, comfort, and space—perfect for school outings, educational trips, and academic tours."
    }
],
"tableData": [
    ["Rent Luxury Force Urbania in Pune", "Affordable Luxury Force Urbania Bus Hire Pune"],
    ["Luxury Urbania Rental Service Pune", "Rent a Luxury Force Urbania Bus for Corporate Events in Pune"],
    ["Luxury Urbania Bus Hire for Wedding Functions Pune", "Force Urbania Luxury Bus for Family Trips Pune"],
    ["Rent Luxury Urbania Bus for Outstation Tours in Pune", "Urbania Luxury Bus Hire for Group Travel Pune"],
    ["Luxury Urbania Bus on Rent for Sightseeing Tours Pune", "Rent a Luxury Urbania Bus for School Trips Pune"]
],


    


"whychoose": [
    {
        "WhyChooseheading": "Premium Luxury Force Urbania on Rent in Pune",
        "WhyChoosedescription": "Samarth Travels offers the all-new Luxury Force Urbania on rent in Pune, ideal for travelers seeking a first-class travel experience. Whether you're booking for a business trip, family vacation, VIP transfer, or wedding, the Urbania delivers comfort, elegance, and a premium ride unlike any other in its class."
    },
    {
        "WhyChooseheading": "Luxury Interiors Designed for Elite Comfort",
        "WhyChoosedescription": "Our Force Urbania features premium leather seats, ambient lighting, individual AC vents, USB charging ports, and a super-silent cabin. With ample legroom, pushback seating, and superior suspension, your ride is smooth, stylish, and incredibly relaxing—perfect for city travel or outstation journeys."
    },
    {
        "WhyChooseheading": "Ideal for Executive and VIP Travel",
        "WhyChoosedescription": "Whether you’re transporting VIP guests, corporate executives, or high-end tourists, the Force Urbania makes a lasting impression. The vehicle’s upscale design, along with its modern features, ensures you or your guests travel in comfort and class, with a dedicated chauffeur ensuring a hassle-free ride."
    },
    {
        "WhyChooseheading": "Experienced Chauffeurs for Safe and Professional Travel",
        "WhyChoosedescription": "Our Urbania rentals come with trained, uniformed chauffeurs who are punctual, courteous, and experienced. They are well-acquainted with city and highway routes, providing a safe, smooth, and professional travel experience from start to finish."
    },
    {
        "WhyChooseheading": "Perfect for Corporate Travel, Weddings, and VIP Airport Transfers",
        "WhyChoosedescription": "The Luxury Force Urbania is the vehicle of choice for premium events and travel. From airport pick-ups to corporate roadshows, destination weddings, or weekend getaways, it adds a touch of class and comfort to every trip. Available for single-day or multi-day rentals."
    },
    {
        "WhyChooseheading": "Flexible Booking and 24/7 Availability",
        "WhyChoosedescription": "Samarth Travels offers round-the-clock availability for the Force Urbania. Whether you need it early morning, late night, or for multiple days, we adjust to your schedule. Booking is quick and seamless via our website or customer support team."
    },
    {
        "WhyChooseheading": "Well-Maintained and Sanitized for Every Ride",
        "WhyChoosedescription": "We maintain our luxury fleet to the highest standards. The Urbania is cleaned, sanitized, and inspected before every trip, ensuring safety, hygiene, and a premium feel every time you step inside."
    },
    {
        "WhyChooseheading": "Multiple Payment Modes and Transparent Pricing",
        "WhyChoosedescription": "We offer upfront, transparent pricing with no hidden charges. Choose from various payment options—cash, UPI, credit/debit cards, or digital wallets—for a smooth and stress-free rental experience."
    }
]






















    }

const faqData = [
    {
        id: 1,
        question: 'How do I rent a Luxury Force Urbania in Pune with Samarth Travels?',
        answer: 'Renting a Luxury Force Urbania with Samarth Travels is easy and hassle-free. You can book directly through our website or contact our customer service team. Just provide your travel details like date, duration, and destination, and we’ll arrange the Urbania for your trip.',
    },
    {
        id: 2,
        question: 'What features does the Luxury Force Urbania offer?',
        answer: 'The Luxury Force Urbania is equipped with premium features such as pushback captain seats, individual AC vents, reading lights, USB charging ports, a modern infotainment system, and excellent suspension for a smooth ride. It’s ideal for VIP travel, business trips, and premium tours.',
    },
    {
        id: 3,
        question: 'Is the Force Urbania suitable for long-distance journeys?',
        answer: 'Yes, the Luxury Force Urbania is perfect for long-distance travel. With high-end comfort and spacious interiors, it ensures a relaxed journey whether you’re traveling intercity or on a weekend getaway.',
    },
    {
        id: 4,
        question: 'How many passengers can the Urbania accommodate?',
        answer: 'The Urbania typically accommodates 10 to 17 passengers, depending on the configuration. It’s ideal for small groups looking for comfort, style, and reliability during travel.',
    },
    {
        id: 5,
        question: 'What is included in the Urbania rental package?',
        answer: 'The rental includes the Luxury Force Urbania vehicle, a professional driver, fuel, and basic amenities. Any additional charges such as tolls, parking, or state permits will be clearly communicated during booking.',
    },
    {
        id: 6,
        question: 'Can I hire the Urbania for airport transfers, weddings, or business travel?',
        answer: 'Absolutely! The Urbania is perfect for various purposes including airport transfers, VIP guest travel, weddings, corporate events, and luxury sightseeing tours in and around Pune.',
    },
    {
        id: 7,
        question: 'Is 24/7 support available for Urbania bookings?',
        answer: 'Yes, Samarth Travels offers round-the-clock customer support to assist with all your booking and service-related needs. We’re here to make your travel experience smooth and luxurious.',
    },
];

const testimonials = [
    {
        name: 'Mr. Rajeev Sharma',
        role: 'Business Consultant',
        text: 'I booked the Luxury Force Urbania for a client pickup from Pune Airport. The vehicle was top-notch, clean, and extremely comfortable. My client was impressed. Samarth Travels never disappoints!',
        image: '/img/testimonial/testi_2_54.jpg',
    },
    {
        name: 'Ms. Anjali Deshmukh',
        role: 'Event Manager',
        text: 'We used the Force Urbania for transporting VIP guests during a corporate event in Pune. The vehicle was luxurious, the driver was professional, and the overall experience was excellent. Highly recommended for premium travel!',
        image: '/img/testimonial/testi_2_55.jpg',
    },
];



























    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9860256019",
            "+91 9527500025",

        ],
        email: "samarthtravels9119@gmail.com"
    };


   const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: " Tempo Traveller Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: " Tempo Traveller on Rent Pune",
        },
        {
            place: "/images/keyword/3.jpg",
            text: " Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: " Tempo Traveller on Rent",
        },
        {
            place: "/images/keyword/5.jpg",
            text: " Tempo Traveller Rent in Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: " Tempo Traveller Hire in Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: " Mini Bus for Rent",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Bus on Rent Hire",
        },

        {
            place: "/images/keyword/9.jpg",
            text: " Bus on Rent Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: " Bus Rental in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: " Hire Tempo Traveller",
        },
        {
            place: "/images/keyword/12.jpg",
            text: " Bus Hire in Pune",
        },
        {
            place: "/images/keyword/13.jpg",
            text: " Ac Tempo Traveller Rent Pune",
        },
        {
            place: "/images/keyword/14.jpg",
            text: " Bus Hire For Outstation",
        },
        {
            place: "/images/keyword/15.jpg",
            text: " Bus on Rent for Local",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Bus Rental For Wedding",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Bus Rent for Marriage",
        },
        {
            place: "/images/keyword/18.jpg",
            text: " Bus Rental For Corporate Events",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "  Bus Rental for Tour",
        },

        {
            place: "/images/keyword/20.jpg",
            text: "Bus Rental For Corporate in Pune",
        },
        {
            place: "/images/keyword/21.jpg",
            text: " Tempo Traveller on Rent in Pune",
        },
        {
            place: "/images/keyword/22.jpg",
            text: " AC Bus On Rent",
        },
        {
            place: "/images/keyword/23.jpg",
            text: " Non Ac Bus Rental Service",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Bus on Hire on Pune to Mahabaleshwar Package Tour ",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Bus Hire for Picnic",
        },
    ];


    const images = [
        { src: "/images/fleets/1.jpg", alt: "Image 1" },
        { src: "/images/fleets/2.jpg", alt: "Image 1" },
        { src: "/images/fleets/3.jpg", alt: "Image 1" },
        { src: "/images/fleets/4.jpg", alt: "Image 1" },
        { src: "/images/fleets/5.jpg", alt: "Image 1" },
        { src: "/images/fleets/6.jpg", alt: "Image 1" },
        { src: "/images/fleets/7.jpg", alt: "Image 1" },
        { src: "/images/fleets/8.jpg", alt: "Image 1" },
        { src: "/images/fleets/9.jpg", alt: "Image 1" },


    ];



const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Luxury Force Urbania on Rent in Pune",
  "image": "https://samarthtravels.com/assets/images/luxury-force-urbania-pune.jpg",
  "description": "Rent a Luxury Force Urbania in Pune for corporate events, weddings, family trips, and outstation tours. Affordable luxury bus options available for group travel, sightseeing tours, and school trips.",
  "brand": {
    "@type": "Brand",
    "name": "Samarth Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5471"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "10000",
    "availability": "https://schema.org/InStock",
    "url": "https://samarthtravels.com/luxury-force-urbania-on-rent-pune"
  }
};
<Helmet>
  <title>Luxury Force Urbania on Rent in Pune | Affordable & Luxury Options | Samarth Travels</title>
  <meta 
    name="description" 
    content="Rent a Luxury Force Urbania in Pune for corporate events, weddings, family trips, and outstation tours. Affordable luxury bus options available for group travel, sightseeing tours, and school trips." 
  />
  <meta 
    name="keywords" 
    content="Rent Luxury Force Urbania in Pune, Affordable Luxury Force Urbania Bus Hire Pune, Luxury Urbania Rental Service Pune, Rent a Luxury Force Urbania Bus for Corporate Events in Pune, Luxury Urbania Bus Hire for Wedding Functions Pune, Force Urbania Luxury Bus for Family Trips Pune, Rent Luxury Urbania Bus for Outstation Tours in Pune, Urbania Luxury Bus Hire for Group Travel Pune, Luxury Urbania Bus on Rent for Sightseeing Tours Pune, Rent a Luxury Urbania Bus for School Trips Pune" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>




    return (
        <div>


<Helmet>
  <title>Luxury Force Urbania on Rent in Pune | Affordable & Luxury Options | Samarth Travels</title>
  <meta 
    name="description" 
    content="Rent a Luxury Force Urbania in Pune for corporate events, weddings, family trips, and outstation tours. Affordable luxury bus options available for group travel, sightseeing tours, and school trips." 
  />
  <meta 
    name="keywords" 
    content="Rent Luxury Force Urbania in Pune, Affordable Luxury Force Urbania Bus Hire Pune, Luxury Urbania Rental Service Pune, Rent a Luxury Force Urbania Bus for Corporate Events in Pune, Luxury Urbania Bus Hire for Wedding Functions Pune, Force Urbania Luxury Bus for Family Trips Pune, Rent Luxury Urbania Bus for Outstation Tours in Pune, Urbania Luxury Bus Hire for Group Travel Pune, Luxury Urbania Bus on Rent for Sightseeing Tours Pune, Rent a Luxury Urbania Bus for School Trips Pune" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <div className="breadcumb-wrapper" data-bg-src="/images/breadcumb-bg.jpg">
                <div className="container">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title text-center">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>



            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/34.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Samarth Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQSection faqs={faqData} accordionId="drivingAccordion" />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <Testimonialskeyword
                                data={testimonials}
                                title="What Our Clients Are Saying"
                                subtitle="Customer Feedback"
                            />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #FF8F1F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#FF8F1F' }}>
                                            <h4 className=" lead fw-semibold whitt textt-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919860256019" className="d-block  text-white">+91 9860256019</a>
                                                <a href="tel:+919527500025" className="d-block  text-white">+91 9527500025</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#FF8F1F' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Email</h4>
                                                <a href="mailto:samarthtravels9119@gmail.com" className=" text-white d-block">
                                                    samarthtravels9119@gmail.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#FF8F1F' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Samarth Travels <br />
                                                        Flat no 201, Juhi Building, Suyash Shrushti Society, Tukai darshan Hadapsar, Pune- 411028
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Luxuryforceurbaniaonrent;